/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	Component
} from '@angular/core';
import {
	PageContextDirective
} from '@shared/directives/page-context.directive';
import {
	ResolverService
} from '@shared/services/resolver.service';

@Component({
	selector: 'app-defaults',
	templateUrl: './defaults.component.html'
})

/**
 * A component representing an instance of the user interface defaults
 * component.
 *
 * @export
 * @class DefaultsComponent
 * @extends {PageContextDirective}
 */
export class DefaultsComponent
	extends PageContextDirective
{
	/**
	 * Creates an instance of the defaults component.
	 *
	 * @param {ResolverService} resolver
	 * The resolver service used for dynamic logic and business rules.
	 * @memberof DefaultsComponent
	 */
	public constructor(
		public resolver: ResolverService)
	{
		super(resolver);
	}
}